<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="abbrs">
<h1 class="ctfm"><a class="page" id="pxiii"></a><a class="xref" href="#/chimckay0006#toc">Abbreviations</a></h1>
<table style="border-bottom:0;">
<colgroup>
<col width="15%"/>
<col width="85%"/>
</colgroup>
<tbody><tr>
<td>
<p class="td"><abbr>ACT</abbr></p>
</td>
<td>
<p class="td">AIDS Committee of Toronto</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>ACT[-]UP</abbr></p>
</td>
<td>
<p class="td">AIDS Coalition to Unleash Power</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>AID</abbr></p>
</td>
<td>
<p class="td">Acquired Immune Deficiency</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>AIDS</abbr></p>
</td>
<td>
<p class="td">acquired immune deficiency syndrome, <i>also called</i> acquired immunodeficiency syndrome</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>APA</abbr></p>
</td>
<td>
<p class="td">American Psychiatric Association</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>ARV</abbr></p>
</td>
<td>
<p class="td">AIDS-related virus</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>ASO</abbr></p>
</td>
<td>
<p class="td">AIDS Service Organization</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>Band</i></abbr></p>
</td>
<td>
<p class="td"><i>And the Band Played On</i></p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>BAR</i></abbr></p>
</td>
<td>
<p class="td"><i>Bay Area Reporter</i></p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>BCGLA</abbr></p>
</td>
<td>
<p class="td">British Columbia Gay and Lesbian Archives</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>CAJ</abbr></p>
</td>
<td>
<p class="td">Canadian Association of Journalists</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>CAS</abbr></p>
</td>
<td>
<p class="td">Canadian AIDS Society</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>CBC</abbr></p>
</td>
<td>
<p class="td">Canadian Broadcasting Corporation</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>CDC</abbr></p>
</td>
<td>
<p class="td">Centers for Disease Control</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>CEH</abbr></p>
</td>
<td>
<p class="td">Center for Environmental Health</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>CID</abbr></p>
</td>
<td>
<p class="td">Center for Infectious Diseases</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>CIJ</abbr></p>
</td>
<td>
<p class="td">Centre for Investigative Journalism</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>CLGA</abbr></p>
</td>
<td>
<p class="td">Canadian Lesbian and Gay Archives</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>CMV</abbr></p>
</td>
<td>
<p class="td">cytomegalovirus</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>CPS</abbr></p>
</td>
<td>
<p class="td">Center for Prevention Services</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>EIS</abbr></p>
</td>
<td>
<p class="td">Epidemic Intelligence Service</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>EPO</abbr></p>
</td>
<td>
<p class="td">Epidemiology Program Office</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>GMHC</abbr></p>
</td>
<td>
<p class="td">Gay Men’s Health Crisis</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>GRID</abbr></p>
</td>
<td>
<p class="td">gay related immune deficiency</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>HAART</abbr></p>
</td>
<td>
<p class="td">highly active antiretroviral therapy</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>HIV</abbr></p>
</td>
<td>
<p class="td">human immunodeficiency virus</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><a class="page" id="pxiv"></a>HLTV-III</abbr></p>
</td>
<td>
<p class="td">human T-cell lymphotropic virus type III</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>IV</abbr></p>
</td>
<td>
<p class="td">intravenous</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>KCL</abbr></p>
</td>
<td>
<p class="td">King’s College London</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>KS</abbr></p>
</td>
<td>
<p class="td">Kaposi’s sarcoma</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>KS/OI</abbr></p>
</td>
<td>
<p class="td">Kaposi’s sarcoma and opportunistic infections</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>LAV</abbr></p>
</td>
<td>
<p class="td">lymphadenopathy-associated virus</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>LCDC</abbr></p>
</td>
<td>
<p class="td">Laboratory Centre for Disease Control</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>LGBT</abbr></p>
</td>
<td>
<p class="td">lesbian, gay, bisexual, and transgender/transsexual</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>MMWR</i></abbr></p>
</td>
<td>
<p class="td"><i>Morbidity and Mortality Weekly Report</i></p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>NAC-AIDS</abbr></p>
</td>
<td>
<p class="td">National Advisory Committee on AIDS</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>NCAB</abbr></p>
</td>
<td>
<p class="td">National Cancer Advisory Board</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>NCI</abbr></p>
</td>
<td>
<p class="td">National Cancer Institute</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>NIH</abbr></p>
</td>
<td>
<p class="td">National Institutes of Health</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>NYN</i></abbr></p>
</td>
<td>
<p class="td"><i>New York Native</i></p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>NYU</abbr></p>
</td>
<td>
<p class="td">New York University</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>OI</abbr></p>
</td>
<td>
<p class="td">opportunistic infection</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>OPV</abbr></p>
</td>
<td>
<p class="td">oral polio vaccine</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>ORTEP</abbr></p>
</td>
<td>
<p class="td">Oak Ridge Thermal Ellipsoid Plot</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>PCC</abbr></p>
</td>
<td>
<p class="td">Portland Community College</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>PCP</abbr></p>
</td>
<td>
<p class="td"><i>Pneumocystis carinii</i> pneumonia</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>PLWH</abbr></p>
</td>
<td>
<p class="td">person living with HIV/AIDS</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>PHS</abbr></p>
</td>
<td>
<p class="td">[United States] Public Health Service</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>PWA</abbr></p>
</td>
<td>
<p class="td">person with AIDS <i>or</i> the group People with AIDS</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>SARS</abbr></p>
</td>
<td>
<p class="td">severe acute respiratory syndrome</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>SES</abbr></p>
</td>
<td>
<p class="td">socioeconomic status</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>SFAF</abbr></p>
</td>
<td>
<p class="td">San Francisco AIDS Foundation</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>SFPL</abbr></p>
</td>
<td>
<p class="td">San Francisco Public Library</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>SIV</abbr></p>
</td>
<td>
<p class="td">simian immunodeficiency virus</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>STDs</abbr></p>
</td>
<td>
<p class="td">sexually transmitted diseases</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>STIs</abbr></p>
</td>
<td>
<p class="td">sexually transmitted infections</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>TB</abbr></p>
</td>
<td>
<p class="td">tuberculosis</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>UCSF</abbr></p>
</td>
<td>
<p class="td">University of California–San Francisco</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>UN</abbr></p>
</td>
<td>
<p class="td">United Nations</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>VD</abbr></p>
</td>
<td>
<p class="td">venereal disease</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>VDCD</abbr></p>
</td>
<td>
<p class="td">Venereal Disease Control Division</p>
</td>
</tr>
</tbody></table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-mckay-0008.vue?dafdf93a